import React from 'react';
import P, { InferProps } from 'prop-types';
import TextInput from './text-field';
import Grid from '@mui/material/Grid';

function InfoFields({
  setChange,
  setValidation,
  fields,
  isReadOnly,
}: InferProps<typeof InfoFields.propTypes>) {
  return (
    <Grid container spacing={3}>
      {fields.map((field) => (
        <Grid item key={field.id}>
          <TextInput
            field={field}
            setChange={setChange}
            setValidation={setValidation}
            key={field.id}
            isReadOnly={isReadOnly}
          />
        </Grid>
      ))}
    </Grid>
  );
}

InfoFields.propTypes = {
  setChange: P.func.isRequired,
  setValidation: P.func.isRequired,
  isReadOnly: P.bool,
  fields: P.arrayOf(
    P.shape({
      title: P.string.isRequired,
      id: P.string.isRequired,
      type: P.string.isRequired,
      validation: P.any,
      key: P.string.isRequired,
      value: P.oneOfType([P.string, P.number]),
      isTeamDataValue: P.bool,
    }).isRequired
  ).isRequired,
};

export default React.memo(InfoFields);
